<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="50%"
  >
    <el-form
      ref="curdForm"
      size="small"
      :model="curdForm"
      :rules="rules"
      label-position="right"
      label-width="120px"
    >
      <el-row :gutter="12">
        <el-col>
          <el-form-item label="作业名称：" prop="workName" required>
            <el-input
              v-model="curdForm.workName"
              placeholder="请输入作业名称"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="作业描述：" prop="workDesc" required>
            <el-input
              type="textarea"
              rows="2"
              v-model="curdForm.workDesc"
              placeholder="请输入作业描述"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="作业学分：" prop="workCredit" required>
            <el-input-number
              v-model="curdForm.workCredit"
              :min="0"
              :step="0.1"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="截止时间：" prop="deadline" required>
            <el-date-picker
              type="datetime"
              placeholder="请选择截止时间"
              v-model="curdForm.deadline"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            class="scale"
            label="是否必修："
            prop="isRequired"
            required
          >
            <el-radio-group v-model="curdForm.isRequired" required>
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            class="scale"
            label="允许补交："
            prop="allowRemedy"
            required
          >
            <el-radio-group v-model="curdForm.allowRemedy" required>
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col v-if="curdForm.allowRemedy == 1">
          <el-form-item label="补交截止时间：" prop="remedyDeadline" required>
            <el-date-picker
              type="datetime"
              :disabled="!curdForm.deadline"
              placeholder="请选择补交截止时间"
              v-model="curdForm.remedyDeadline"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col v-if="curdForm.allowRemedy == 1">
          <el-form-item label="补交学分：" prop="remedyCredit" required>
            <el-input-number
              v-model="curdForm.remedyCredit"
              :min="0"
              :step="0.1"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item class="scale" label="附件：" prop="attachmentList">
            <upload
              ref="upload"
              :limit="1"
              :path="'class/work'"
              v-model="curdForm.attachmentList"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="createData()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus";
import Upload from "@/components/upload/index";
import moment from "moment";
import {
  saveClassWork,
  updateClassWork,
  getClassWorkInfo
} from "@/api/classWork";
import { getDataMap } from "@/api/sysParam";

export default {
  components: { butn, Upload },
  data() {
    const that = this;
    return {
      Bus,
      deptTreeList: [],
      rules: {
        workName: [
          {
            required: true,
            message: "请输入作业名称",
            trigger: ["blur", "change"]
          },
          {
            min: 0,
            max: 50,
            message: "最多输入50个字",
            trigger: ["blur", "change"]
          }
        ],
        workDesc: [
          {
            required: true,
            message: "请输入作业描述",
            trigger: ["blur", "change"]
          },
          {
            min: 0,
            max: 300,
            message: "最多输入300个字",
            trigger: ["blur", "change"]
          }
        ],
        deadline: [
          {
            required: true,
            message: "请选择截止时间",
            trigger: ["change", "blur"]
          }
        ],
        remedyDeadline: [
          {
            required: true,
            message: "请选择补交截止时间",
            trigger: ["change", "blur"]
          }
        ]
      },
      curdTitle: "",
      CUFlag: false,
      Dflag: false,
      publicData: [],
      curdForm: {
        classId: "",
        workCredit: 0,
        isRequired: 1,
        allowRemedy: 1,
        remedyCredit: 0,
        attachment: "",
        attachmentList: []
      },
      classId: "",
      editId: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < moment(that.curdForm.deadline).valueOf();
        }
      }
    };
  },
  created() {
    let _this = this;
    Bus.$on("ReceiveMessage", function(item) {
      _this.$nextTick(() => {
        _this.curdTitle = "布置作业";
        _this.classId = item.classId;
        _this.command = item.uuid == "" ? saveClassWork : updateClassWork;
        _this.CUFlag = true;
        if (item.uuid) {
          getClassWorkInfo(item.uuid).then(res => {
            if (!res || res.code != 0) return;
            _this.curdForm = res.data;
            if (
              _this.curdForm.attachment != null &&
              _this.curdForm.attachment != ""
            ) {
              _this.curdForm.attachmentList = JSON.parse(
                _this.curdForm.attachment
              );
            } else {
              _this.curdForm.attachmentList = [];
            }
          });
        }
      });
    });

    getDataMap("IS_VALID").then(res => {
      if (!res || res.code != 0) return;
      this.publicData = res.data
        .sort(function(a, b) {
          return parseInt(b.paramKey) - parseInt(a.paramKey);
        })
        .map(ele => {
          ele.paramKey = parseInt(ele.paramKey);
          return ele;
        });
    });
  },
  methods: {
    //提交数据
    createData() {
      this.$refs.curdForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (
            this.curdForm.allowRemedy === 1 &&
            this.curdForm.deadline > this.curdForm.remedyDeadline
          ) {
            //允许补交->补交截止时间必须晚于截止时间
            this.$message({
              message: "补交截止时间必须晚于截止时间",
              type: "warning"
            });
            return;
          }
          const params = Object.assign({}, this.curdForm);
          if (this.curdForm.attachmentList.length > 0) {
            params["attachment"] = JSON.stringify(this.curdForm.attachmentList);
          } else {
            params["attachment"] = "";
          }
          params.classId = this.classId;
          this.command(params).then(res => {
            this.loading = false;
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              Bus.$emit("reload");
              this.CUFlag = false;
            }
          });
        }
      });
    },
    closeDialog() {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs["curdForm"].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped></style>
